module.exports = __webpack_public_path__ + "img/talent-tree.fcdaf68e.png";